'use client';

declare global {
  interface Window {
    $chatwoot?: {
      toggle: () => void;
    };
  }
}

import { Button } from '@headlessui/react';
import clsx from 'clsx';

export default function ChatButton({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Button
      className={clsx('flex items-center', className)}
      onClick={() => window.$chatwoot?.toggle()}
    >
      {children}
    </Button>
  );
}
